import { Schema as S } from "effect";
import { defineMessageUnion } from "foldkit/message";

import {
	createNote,
	getNote,
	listFolders,
	saveNote,
} from "../../api/commands/notes";
import { getRecord } from "../../api/commands/records";
import * as NoteEditor from "../../widgets/noteEditor";

export const Message = defineMessageUnion({
	/** `id` drops an answer for a note the page has moved off. */
	CompletedFetchNote: {
		id: S.String,
		generation: S.Number,
		now: S.Number,
		result: getNote.Result,
	},
	CompletedFetchFolders: {
		generation: S.Number,
		result: listFolders.Result,
	},
	ToggledFolder: { path: S.String },
	CompletedFetchRecord: {
		noteId: S.String,
		recordId: S.String,
		generation: S.Number,
		result: getRecord.Result,
	},
	/** `raw` opens that ambiguous link's chooser; null closes it. */
	ToggledChooser: { raw: S.NullOr(S.String) },
	ClickedCreateLinked: { target: S.String },
	CompletedCreate: { generation: S.Number, result: createNote.Result },
	CompletedNavigate: {},
	/** Discards unsaved changes. */
	ClickedCancel: {},
	ChangedTitle: { value: S.String },
	GotNoteEditorMessage: { message: NoteEditor.Message },
	CompletedNoteEditorCommand: {},
	ClickedSave: {},
	CompletedSave: {
		id: S.String,
		generation: S.Number,
		result: saveNote.Result,
	},
	ClickedReload: {},
});
export type Message = typeof Message.Type;
